"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ErrorMessage_1 = require("./ErrorMessage");
const mapPresentationToProps_1 = require("./mapPresentationToProps");
exports.ERROR_DISPLAY_TIME = 5000;
exports.RETRY_PRESENTATION_TIME = 15000;
const raydiantAppIdentifier = Symbol();
exports.isRaydiantApp = (component) => component.isRaydiantApp === raydiantAppIdentifier;
function withRaydiantApp(App) {
    const appName = App.name || App.displayName;
    class WrappedComponent extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {
                isPlaying: false,
                playCount: 0,
                error: null,
            };
            this.hasSentReady = false;
            this.handlePresentationReady = () => {
                // Emit presentation_ready after fetching initial resources.
                // Applications are preloaded before switching to the next
                // presentation and this will notify the device when it is
                // ready to become the active presentation.
                if (!this.hasSentReady) {
                    this.props.miraEvents.emit('presentation_ready');
                    this.hasSentReady = true;
                }
            };
            this.handlePresentationComplete = () => {
                // All apps must emit a presentation_complete event to trigger the
                // next presentation to run. This could be after a video end event,
                // a user-defined duration from application variables, an error, etc...
                this.props.miraEvents.emit('presentation_complete');
            };
            this.handlePresentationError = (error) => {
                const { presentation } = this.props;
                // Fire presentation complete immediately if we are currently playing.
                // Otherwise, fire presentation_ready so that play is triggered.
                if (this.state.isPlaying) {
                    this.handlePresentationComplete();
                }
                else {
                    this.handlePresentationReady();
                }
                // Show the error.
                this.setState({ error });
                // tslint:disable-next-line
                console.error(`Presentation error for '${presentation.name}': ${error.message}`);
            };
        }
        componentDidMount() {
            this.props.miraEvents.on('play', () => {
                const { error, playCount } = this.state;
                if (error) {
                    // An error occurred before we received the play event, delay
                    // the presentation_complete event to allow photon enough time
                    // to queue the next presentation. If the presentation is the only
                    // one in the sequence, we will attempt to load it again in case
                    // the error is due to a temporary network disconnect.
                    if (playCount === 0) {
                        this.errorDisplayTimeout = setTimeout(this.handlePresentationComplete, exports.ERROR_DISPLAY_TIME);
                    }
                    else {
                        this.retryTimeout = setTimeout(() => this.setState({ error: null }), exports.RETRY_PRESENTATION_TIME);
                    }
                }
                this.setState({
                    isPlaying: true,
                    playCount: playCount + 1,
                });
            });
        }
        componentWillReceiveProps() {
            // Clear any previous errors to allow the app to recover.
            this.setState({ error: null });
        }
        componentWillUnmount() {
            clearTimeout(this.errorDisplayTimeout);
            clearTimeout(this.retryTimeout);
        }
        render() {
            const { error, isPlaying, playCount } = this.state;
            if (error) {
                return (React.createElement(ErrorMessage_1.default, { title: "Sorry, unable to display this content.", message: error.message }));
            }
            const _a = this.props, { presentation, device, miraEvents, miraFileResource, miraRequestResource, strings, isDashboard, isThumbnail } = _a, legacyApplicationVars = __rest(_a, ["presentation", "device", "miraEvents", "miraFileResource", "miraRequestResource", "strings", "isDashboard", "isThumbnail"]);
            return (React.createElement(App, Object.assign({}, legacyApplicationVars, { presentation: mapPresentationToProps_1.default(presentation), device: device, isPlaying: isPlaying, playCount: playCount, onReady: this.handlePresentationReady, onComplete: this.handlePresentationComplete, onError: this.handlePresentationError, miraFileResource: miraFileResource, miraRequestResource: miraRequestResource, strings: strings, isDashboard: isDashboard, isThumbnail: isThumbnail, miraEvents: miraEvents })));
        }
    }
    WrappedComponent.displayName = `withRaydiantApp(${appName || 'App'})`;
    WrappedComponent.isRaydiantApp = raydiantAppIdentifier;
    return WrappedComponent;
}
exports.default = withRaydiantApp;
//# sourceMappingURL=withRaydiantApp.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/withRaydiantApp.js